import React, { useRef, useState } from "react";
import ImageGallery from "react-image-gallery";
import "./style.scss";
import "react-image-gallery/styles/scss/image-gallery.scss";
import { ProductModelViewer } from "../modelViewer";
import { Button, Modal } from "antd";
import { WithTranslation, withTranslation } from "react-i18next";
import {
  BackwardOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  ForwardOutlined,
} from "@ant-design/icons";
import { WIDTH_MOBILE } from "../../common/constant";

interface IProductBannerProps extends WithTranslation {
  banners: any[];
  productName: string;
  imageDescription: string;
}

const ProductBanner = (props: IProductBannerProps) => {
  const { banners, productName, imageDescription, t } = props;
  const [slideIndex, setSlideIndex] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const ref = useRef<ImageGallery>(null);
  const [itemModel, setItemModel] = useState<any>(null);
  const [images, setImages] = useState<any>([]);
  const { innerWidth } = window;

  React.useEffect(() => {
    setSlideIndex(0);

    let _images = [];

    if (innerWidth > WIDTH_MOBILE) {
      _images = banners.map((item: any) => ({
        original: item.imageUrl?.path,
        thumbnail: item.imageUrl?.path_thumb,
        category: item.imageUrl?.category,
      }));
    } else {
      _images = banners
        .filter((banner: any) => banner.imageUrl?.category != "MODEL_3D")
        .map((item: any) => ({
          original: item.imageUrl?.path,
          thumbnail: item.imageUrl?.path_thumb,
          category: item.imageUrl?.category,
        }));
    }

    setImages(_images);
  }, [banners]);

  const onClickThumbnail = (item: any, index: number) => {
    if (item.category == "MODEL_3D") {
      setIsModalVisible(true);
      setItemModel(item);
    } else {
      ref.current?.slideToIndex(index);
    }
  };
  const handleClose = () => {
    setIsModalVisible(false);
    setItemModel(null);
  };

  const handleOnMouseOver = () => {
    if (!ref.current) {
      console.log("ProductBanner: ref is null!!");
      return;
    }

    ref.current.pause();
  };
  const handleOnMouseLeaver = () => {
    if (!ref.current) {
      console.log("ProductBanner: ref is null!!");
      return;
    }

    ref.current.play();
  };

  return (
    <>
      {
        <Modal
          title={productName}
          visible={isModalVisible}
          onOk={handleClose}
          onCancel={handleClose}
          centered={true}
          width={"100%"}
          okText={null}
          cancelText={null}
          footer={[
            <Button type="primary" onClick={handleClose}>
              {t("close")}
            </Button>,
          ]}
          className="3d-modal">
          <ProductModelViewer
            poster={itemModel?.thumbnail}
            src={itemModel?.original}
            product_name={productName}
          />
        </Modal>
      }

      {banners.length ? (
        <div className="kd-product-detail-banner-container">
          {images && (
            <>
              {slideIndex > 0 ? (
                <a
                  onClick={() => ref.current?.slideToIndex(slideIndex - 1)}
                  className="btn-prev-slide-img-product">
                  {slideIndex !== 0 && slideIndex !== images.length - 1 ? (
                    <CaretLeftOutlined />
                  ) : (
                    <BackwardOutlined />
                  )}
                </a>
              ) : null}
              <ImageGallery
                ref={ref}
                autoPlay
                slideInterval={4000}
                items={images?.filter((x: any) => x.category !== "MODEL_3D")}
                showPlayButton={false}
                showFullscreenButton={false}
                renderItem={(item: any) => (
                  <div className="image-gallery-img">
                    <img src={item.original} />
                    <span>{imageDescription}</span>
                  </div>
                )}
                showThumbnails={false}
                onSlide={(i) => setSlideIndex(i)}
                onMouseOver={handleOnMouseOver}
                onMouseLeave={handleOnMouseLeaver}
              />
              {slideIndex < images.length - 1 ? (
                <a
                  onClick={() => ref.current?.slideToIndex(slideIndex + 1)}
                  className="btn-next-slide-img-product">
                  {slideIndex !== 0 && slideIndex !== images.length - 1 ? (
                    <CaretRightOutlined />
                  ) : (
                    <ForwardOutlined />
                  )}
                </a>
              ) : null}
            </>
          )}
          {images && (
            <div className="image-gallery-thumbnails-wrapper bottom">
              <div className="image-gallery-thumbnails">
                <div
                  className="image-gallery-thumbnails-container"
                  aria-label="Thumbnail Navigation"
                  style={{ transform: "translate3d(0px, 0px, 0px)" }}>
                  {images.map((item: any, i: number) => (
                    <button
                      onClick={() => onClickThumbnail(item, i)}
                      key={i}
                      type="button"
                      tabIndex={i}
                      aria-pressed="true"
                      aria-label={`Go to Slide ${i + 1}`}
                      className={`image-gallery-thumbnail ${
                        slideIndex == i ? "active" : ""
                      }`}>
                      <div className="image-gallery-thumbnail-inner">
                        {item.category == "MODEL_3D" ? (
                          <span className="overlay-3d">
                            <img
                              src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1624353852-icon3D-49.png"
                              alt="Model 3D"
                              style={{ width: 40, opacity: 0.8 }}
                            />
                          </span>
                        ) : null}
                        <img
                          className="image-gallery-thumbnail-image"
                          src={item.thumbnail}
                        />
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default withTranslation()(ProductBanner);
